export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Settings.json?hash=f9ec8985f6affb9b293d8ca33b597891";